import * as React from 'react';

function SvgHddRack(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M4.5 5a.5.5 0 100-1 .5.5 0 000 1zM3 4.5a.5.5 0 11-1 0 .5.5 0 011 0zm2 7a.5.5 0 11-1 0 .5.5 0 011 0zm-2.5.5a.5.5 0 100-1 .5.5 0 000 1z' />
			<path d='M2 2a2 2 0 00-2 2v1a2 2 0 002 2h1v2H2a2 2 0 00-2 2v1a2 2 0 002 2h12a2 2 0 002-2v-1a2 2 0 00-2-2h-1V7h1a2 2 0 002-2V4a2 2 0 00-2-2H2zm13 2v1a1 1 0 01-1 1H2a1 1 0 01-1-1V4a1 1 0 011-1h12a1 1 0 011 1zm0 7v1a1 1 0 01-1 1H2a1 1 0 01-1-1v-1a1 1 0 011-1h12a1 1 0 011 1zm-3-4v2H4V7h8z' />
		</svg>
	);
}

export default SvgHddRack;
